package us.laantech.common.api

import kotlinx.serialization.Serializable


@Serializable
class AuthResult(
    val AccessToken: String,
    val ExpiresIn: Int,
    val IdToken: String,
    val RefreshToken: String? = null,
    val TokenType: String = "Bearer",
)
